/**
 * The audit log, read-only.
 *
 * There is no filter for "hide my own actions" and no delete button, here or
 * in the API. A log its own subjects can curate answers no question worth
 * asking.
 */

import { useAuditLog } from "../../api/queries";
import { Badge, Card, Empty, ErrorNote, Loading } from "../../ui/primitives";

const TONES: Record<string, "bad" | "warn" | "neutral"> = {
  impersonate: "bad",
  organization_suspended: "warn",
  organization_reinstated: "neutral",
  job_requeued: "neutral",
  superuser_granted: "bad",
};

export function AdminAuditPage() {
  const events = useAuditLog();

  if (events.isLoading) return <Loading />;
  if (events.error) return <ErrorNote error={events.error} />;
  if ((events.data ?? []).length === 0) {
    return <Empty title="Nothing recorded yet">Staff actions appear here.</Empty>;
  }

  return (
    <Card>
      <ul className="divide-y divide-line">
        {(events.data ?? []).map((event) => (
          <li key={event.id} className="py-2.5 text-sm">
            <div className="flex flex-wrap items-center gap-2">
              <Badge tone={TONES[event.action] ?? "neutral"}>
                {event.action.replace(/_/g, " ")}
              </Badge>
              {/* The email, not a join to the user row — the record has to
                  outlive the account it names. */}
              <span className="font-medium">{event.actor_email}</span>
              <span className="ml-auto text-xs tabular-nums text-muted">
                {new Date(event.created_at).toLocaleString()}
                {event.ip_address && ` · ${event.ip_address}`}
              </span>
            </div>

            {typeof event.detail.reason === "string" && (
              <p className="mt-1 text-xs text-muted">
                Reason: {event.detail.reason}
              </p>
            )}
          </li>
        ))}
      </ul>
    </Card>
  );
}
